<template>
  <v-menu left offset-y :close-on-content-click="true">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" class="data-list--action-btn" :ripple="false" rounded plain small v-bind="attrs" v-on="on">
        <DotVerticalIcon v-bind="attrs" @click="on.click"></DotVerticalIcon>
      </v-btn>
    </template>
    <v-list flat>
      <v-list-item-group color="primary">
        <v-list-item v-for="(action, index) in actions" :key="index" @click="action.function">
          <v-list-item-icon>
            <v-icon v-text="action.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="action.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  import DotVerticalIcon from "@/components/icons/DotsVerticalIcon";

  export default {
    name: "DataListActions",
    components: {
      DotVerticalIcon,
    },
    props: {
      actions: {
        required: true,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss" scoped>
  .data-list {
    &--action-btn {
      min-width: 29px !important;
      padding: 0 !important;
    }
  }
</style>
